import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Cast extends Bloc {

	constructor (src, ctx) {

		super("cast", src, ctx, true);
		this.f = (src, ins, props) => {
			if (!ins[0])
				return;
			this.src.master.notify("autocast", ins[0]);
			ins[0].play(ins[1], false, true);
			return;
		};
		this.types = [Types.card, Types.entity];
	}
}